export async function decodeGzipBuffer(buf: ArrayBuffer): Promise<string> {
    const source = new ReadableStream({
        start(controller) {
            controller.enqueue(new Uint8Array(buf));
            controller.close();
        }
    });
    const stream = source.pipeThrough(new DecompressionStream('gzip'));
    const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
    const chunks: string[] = [];
    for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
    }
    return chunks.join('');
}
